(function () {
  var root = document.getElementById('litfor');
  if (!root) return;
  var canvas = root.querySelector('canvas');
  var ctx = canvas.getContext('2d');
  var nameIn = root.querySelector('#litfor-name');
  var yearsIn = root.querySelector('#litfor-years');
  var pick = root.querySelector('#litfor-pick');
  var own = root.querySelector('#litfor-own');
  var ownCount = root.querySelector('[data-for="litfor-own"]');
  var nameCount = root.querySelector('[data-for="litfor-name"]');
  var err = root.querySelector('.litfor__error');
  var hidden = {
    name: root.querySelector('[data-litfor="name"]'),
    years: root.querySelector('[data-litfor="years"]'),
    line: root.querySelector('[data-litfor="line"]'),
    flag: root.querySelector('[data-litfor="flag"]')
  };
  var bases = {}, ready = false;

  // Which jar size is picked (9 or 4), read from the Size option buttons.
  function currentSize() {
    var el = document.querySelector('input[name^="Size"]:checked, select[name="options[Size]"]');
    var v = el ? el.value : '9oz';
    return /^4/.test(v) ? 4 : 9;
  }

  function currentScent() {
    var el = document.querySelector('input[name^="Scent"]:checked, select[name="options[Scent]"]');
    return el ? el.value : '';
  }

  // Attach the hidden fields to the product form, like the CLEAR Kit builder does.
  var addBtn = document.querySelector('product-form button[name="add"], form[action*="/cart/add"] button[name="add"]');
  var form = addBtn ? (addBtn.form || addBtn.closest('form')) : null;
  if (form) {
    // form.id can be shadowed by the variant input named "id", so use the attribute.
    var formId = form.getAttribute('id');
    if (!formId) { formId = 'litfor-product-form'; form.setAttribute('id', formId); }
    Object.keys(hidden).forEach(function (k) {
      hidden[k].setAttribute('form', formId);
      hidden[k].disabled = false;
    });
  }

  function lineValue() {
    if (pick.value === '__own') return own.value;
    return pick.value;
  }

  function sync() {
    hidden.name.value = nameIn.value.replace(/\s+/g, ' ').trim();
    hidden.years.value = yearsIn.value.replace(/\s+/g, ' ').trim();
    var ln = lineValue().replace(/\s+/g, ' ').trim();
    hidden.line.value = ln && window.litForSentence ? window.litForSentence(ln.slice(0, 44)) : ln;
    // Empty optional fields send nothing, so they don't clutter the order.
    hidden.years.disabled = !hidden.years.value;
    hidden.line.disabled = !hidden.line.value;
    nameCount.textContent = nameIn.value.length + '/24';
    ownCount.textContent = own.value.length + '/45';
    if (hidden.name.value) { root.classList.remove('litfor--invalid'); err.hidden = true; }
    draw();
  }

  function draw() {
    if (!ready) return;
    var size = currentSize(), g = window.litForGeom[size], dpr = 2;
    if (canvas.width !== g.W * dpr || canvas.height !== g.H * dpr) { canvas.width = g.W * dpr; canvas.height = g.H * dpr; }
    window.drawLitFor(ctx, bases[size] || null, {
      name: nameIn.value || nameIn.placeholder,
      years: yearsIn.value,
      line: lineValue(),
      scent: currentScent()
    }, dpr, size);
  }

  // Redraw when the jar size or scent changes.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.name && /^(Size|Scent|options\[(Size|Scent)\])/.test(t.name)) setTimeout(draw, 0);
  });

  pick.addEventListener('change', function () {
    var mine = pick.value === '__own';
    own.hidden = !mine; ownCount.hidden = !mine;
    if (mine) own.focus();
    sync();
  });
  [nameIn, yearsIn, own].forEach(function (el) { el.addEventListener('input', sync); });

  // A name is required: stop Add to cart and say why, right where they are.
  document.addEventListener('submit', function (e) {
    if (!form || e.target !== form) return;
    sync();
    if (!hidden.name.value) {
      e.preventDefault();
      e.stopImmediatePropagation();
      root.classList.add('litfor--invalid');
      err.hidden = false;
      nameIn.scrollIntoView({ behavior: 'smooth', block: 'center' });
      nameIn.focus({ preventScroll: true });
    }
  }, true);

  function loadFont(family, url) {
    var f = new FontFace(family, 'url(' + url + ')');
    return f.load().then(function (ff) { document.fonts.add(ff); });
  }
  function loadImg(url) {
    return new Promise(function (res) {
      var i = new Image(); i.onload = function () { res(i); }; i.onerror = function () { res(null); }; i.src = url;
    });
  }
  function start() {
    if (!window.drawLitFor) return setTimeout(start, 50);
    Promise.all([
      loadFont('BIW Lit Title', root.dataset.titleFont),
      loadFont('Arimo', root.dataset.bodyFont),
      loadFont('Arimo Bold', root.dataset.boldFont),
      loadImg(root.dataset.base),
      loadImg(root.dataset.base4)
    ]).then(function (r) { bases[9] = r[3]; bases[4] = r[4]; ready = true; sync(); })
      .catch(function () { ready = true; sync(); });
  }
  sync();
  start();
})();
